import $ from 'jquery';

export function HomePage() {
  // Hero animation
  if ($('.homepage__hero').length > 0 && !$('.homepage__hero').hasClass('-animated')) {
    $('.homepage__hero').addClass('-animated');
  }
}
